import template from './dateField.html';
import controller from './dateField.controller';

import datepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    field: '<',
    onUpdate: '&',
  }
};

export default component;
